import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getSession } from "../global";

const Header = () => {
    const [uinfo, setUinfo] = useState(null);

    useEffect(() => {
        const u = getSession('userInfo');
        setUinfo(u);
    }, [])

    return <>
        <div className="navbar-bg" />
        <nav className="navbar navbar-expand-lg main-navbar">
            <form className="form-inline mr-auto hide-toggle-button">
                <ul className="navbar-nav mr-3">
                    <li><a href="#" data-toggle="sidebar" className="nav-link nav-link-lg"><i className="fas fa-bars" /></a></li>
                </ul>
            </form>
                    {/* <li><a href="#" data-toggle="search" className="nav-link nav-link-lg d-sm-none"><i className="fas fa-search" /></a></li> */}
            <ul className="navbar-nav ms-auto">
                {/* <li className="dropdown dropdown-list-toggle">
                    <a href="#" data-toggle="dropdown" className="nav-link nav-link-lg message-toggle beep"><i className="far fa-envelope" /></a>
                    <div className="dropdown-menu dropdown-list dropdown-menu-right">
                        <div className="dropdown-header">
                            Messages
                            <div className="float-right">
                                <a href="#">Mark All As Read</a>
                            </div>
                        </div>
                        <div className="dropdown-list-content dropdown-list-message">
                            <a href="#" className="dropdown-item dropdown-item-unread">
                                <div className="dropdown-item-avatar">
                                    <img alt="image" src="../assets/img/avatar/avatar-1.png" className="rounded-circle" />
                                    <div className="is-online" />
                                </div>
                                <div className="dropdown-item-desc">
                                    <b>Kusnaedi</b>
                                    <p>Hello, Bro!</p>
                                    <div className="time">10 Hours Ago</div>
                                </div>
                            </a>
                            <a href="#" className="dropdown-item dropdown-item-unread">
                                <div className="dropdown-item-avatar">
                                    <img alt="image" src="../assets/img/avatar/avatar-2.png" className="rounded-circle" />
                                </div>
                                <div className="dropdown-item-desc">
                                    <b>Dedik Sugiharto</b>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit</p>
                                    <div className="time">12 Hours Ago</div>
                                </div>
                            </a>
                            <a href="#" className="dropdown-item dropdown-item-unread">
                                <div className="dropdown-item-avatar">
                                    <img alt="image" src="../assets/img/avatar/avatar-3.png" className="rounded-circle" />
                                    <div className="is-online" />
                                </div>
                                <div className="dropdown-item-desc">
                                    <b>Agung Ardiansyah</b>
                                    <p>Sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
                                    <div className="time">12 Hours Ago</div>
                                </div>
                            </a>
                            <a href="#" className="dropdown-item">
                                <div className="dropdown-item-avatar">
                                    <img alt="image" src="../assets/img/avatar/avatar-4.png" className="rounded-circle" />
                                </div>
                                <div className="dropdown-item-desc">
                                    <b>Ardian Rahardiansyah</b>
                                    <p>Duis aute irure dolor in reprehenderit in voluptate velit ess</p>
                                    <div className="time">16 Hours Ago</div>
                                </div>
                            </a>
                            <a href="#" className="dropdown-item">
                                <div className="dropdown-item-avatar">
                                    <img alt="image" src="../assets/img/avatar/avatar-5.png" className="rounded-circle" />
                                </div>
                                <div className="dropdown-item-desc">
                                    <b>Alfa Zulkarnain</b>
                                    <p>Exercitation ullamco laboris nisi ut aliquip ex ea commodo</p>
                                    <div className="time">Yesterday</div>
                                </div>
                            </a>
                        </div>
                        <div className="dropdown-footer text-center">
                            <a href="#">View All <i className="fas fa-chevron-right" /></a>
                        </div>
                    </div>
                </li>
                <li className="dropdown dropdown-list-toggle">
                    <a href="#" data-toggle="dropdown" className="nav-link notification-toggle nav-link-lg beep"><i className="far fa-bell" /></a>
                    <div className="dropdown-menu dropdown-list dropdown-menu-right">
                        <div className="dropdown-header">
                            Notifications
                            <div className="float-right">
                                <a href="#">Mark All As Read</a>
                            </div>
                        </div>
                        <div className="dropdown-list-content dropdown-list-icons">
                            <a href="#" className="dropdown-item dropdown-item-unread">
                                <div className="dropdown-item-icon bg-primary text-white">
                                    <i className="fas fa-code" />
                                </div>
                                <div className="dropdown-item-desc">
                                    Template update is available now!
                                    <div className="time text-primary">2 Min Ago</div>
                                </div>
                            </a>
                            <a href="#" className="dropdown-item">
                                <div className="dropdown-item-icon bg-info text-white">
                                    <i className="far fa-user" />
                                </div>
                                <div className="dropdown-item-desc">
                                    <b>You</b> and <b>Dedik Sugiharto</b> are now friends
                                    <div className="time">10 Hours Ago</div>
                                </div>
                            </a>
                            <a href="#" className="dropdown-item">
                                <div className="dropdown-item-icon bg-success text-white">
                                    <i className="fas fa-check" />
                                </div>
                                <div className="dropdown-item-desc">
                                    <b>Kusnaedi</b> has moved task <b>Fix bug header</b> to <b>Done</b>
                                    <div className="time">12 Hours Ago</div>
                                </div>
                            </a>
                            <a href="#" className="dropdown-item">
                                <div className="dropdown-item-icon bg-danger text-white">
                                    <i className="fas fa-exclamation-triangle" />
                                </div>
                                <div className="dropdown-item-desc">
                                    Low disk space. Let's clean it!
                                    <div className="time">17 Hours Ago</div>
                                </div>
                            </a>
                            <a href="#" className="dropdown-item">
                                <div className="dropdown-item-icon bg-info text-white">
                                    <i className="fas fa-bell" />
                                </div>
                                <div className="dropdown-item-desc">
                                    Welcome to Stisla template!
                                    <div className="time">Yesterday</div>
                                </div>
                            </a>
                        </div>
                        <div className="dropdown-footer text-center">
                            <a href="#">View All <i className="fas fa-chevron-right" /></a>
                        </div>
                    </div>
                </li> */}
                {/* <div className="dropdown"> */}

            <div className="redirect-link">
                <div className="d-none d-lg-inline-block">Do you need help?  Please call us at  <span style={{color: '#e25a0c'}}>(021) 111-202-202</span> </div>
            </div>

            <div className="redirect-link">
                <a href="tracking_2" className="header-icons" title="Tracking">
                    <i className="fa fa-search header-icons" />
                </a>
            </div>

            <div className="redirect-link">
                <a href="userguide" className="header-icons" title="User Guide">
                    <i className="fa fa-question-circle " aria-hidden="true"></i>
                </a>
            </div>

           


                {/* </div> */}

                <div className="dropdown">
                    <a className="nav-link dropdown-toggle nav-link-lg nav-link-user" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                        {/* <img alt="image" src="../assets/img/avatar/avatar-1.png" className="rounded-circle" style={{ marginRight: 10 }} /> */}
                        <div className="d-sm-none d-lg-inline-block">Hi, {uinfo && uinfo.name}</div>
                    </a>
                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuLink">
                         {/* <div className="dropdown-title">Logged in 5 min ago</div>
                        <a href="features-profile.html" className="dropdown-item has-icon" style={{color: 'black'}}>
                            <i className="fa fa-search" /> 
                        </a>
                        <a href="features-activities.html" className="dropdown-item has-icon" style={{color: 'black'}}>
                            <i className="fas fa-bolt" /> Activities
                        </a>
                        <a href="features-settings.html" className="dropdown-item has-icon" style={{color: 'black'}}>
                            <i className="fas fa-cog" /> Settings
                        </a> */}
                        <div className="dropdown-divider" /> 
                        <Link to="/changepassword" className="dropdown-item has-icon text-danger"><i className="fas fa-sign-out-alt" />Change Password</Link>
                        <Link to="/login" className="dropdown-item has-icon text-danger"><i className="fas fa-sign-out-alt" />Logout</Link>
                    </div>
                </div>
            </ul>
        </nav>
    </>
}

export default Header;